import { TeenWellbeing } from "@/components/conversation-details/feedback/teen-wellbeing/teen-wellbeing.tsx";
import { Ratings } from "@/components/conversation-details/feedback/ratings/ratings.tsx";
import { useGetMentorshipFeedback } from "@/lib/api/mentorships.ts";
import { Loader2 } from "lucide-react";

interface FeedbackProps {
  mentorshipId: string;
}

export function Feedback({ mentorshipId }: FeedbackProps) {
  const { data, isLoading, isError } = useGetMentorshipFeedback(mentorshipId);

  return (
    <div className="flex flex-col gap-6 pb-20">
      {isLoading ? (
        <div className="flex min-h-96 items-center justify-center">
          <Loader2 className="h-6 w-6 animate-spin text-zinc-700" />
        </div>
      ) : isError || !data ? (
        <div className="flex min-h-96 items-center justify-center">
          <div className="text-red-500">Error fetching feedback</div>
        </div>
      ) : (
        <>
          <TeenWellbeing
            current={data?.teenWellBeing?.current}
            history={data?.teenWellBeing?.history}
          />
          <Ratings
            averageRating={data?.averageRating}
            ratingList={data?.ratingList}
            match={data?.match}
            continue={data?.continue}
          />
        </>
      )}
    </div>
  );
}
